import { render, staticRenderFns } from "./shop-wholesale.component.vue?vue&type=template&id=816a9c56&scoped=true&"
import script from "./shop-wholesale.component.vue?vue&type=script&lang=js&"
export * from "./shop-wholesale.component.vue?vue&type=script&lang=js&"
import style0 from "./shop-wholesale.component.vue?vue&type=style&index=0&id=816a9c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816a9c56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('816a9c56')) {
      api.createRecord('816a9c56', component.options)
    } else {
      api.reload('816a9c56', component.options)
    }
    module.hot.accept("./shop-wholesale.component.vue?vue&type=template&id=816a9c56&scoped=true&", function () {
      api.rerender('816a9c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/shop-wholesale.component.vue"
export default component.exports